import type { DetailedSurvey } from "@survey-types/survey.core.types";
import type { Property } from "@survey-types/survey.property.types";

/**
 * Get the display index for a property based on visible property filtering rules
 * @param property - The property to get the index for
 * @param survey - The survey containing all properties
 * @returns The zero-based index of the property in the filtered visible properties list (excluding current location properties from numbering)
 */
export const getPropertyDisplayIndex = (
  property: Property,
  survey: DetailedSurvey | null,
): number => {
  if (!survey?.properties) return 0;

  // For current location properties, return 0 (they'll show a star icon instead of a number)
  if (property.isCurrentLocation) return 0;

  // Filter properties for numbering: exclude hidden and current location properties
  const numberableProperties = survey.properties.filter((p: Property) => {
    // Filter out hidden properties
    if (p.isHidden) return false;

    // Filter out current location properties from numbering
    if (p.isCurrentLocation) return false;

    return true;
  });

  // Find the index of the current property in the filtered list
  const index = numberableProperties.findIndex(
    (p: Property) => p.id === property.id,
  );
  return index >= 0 ? index : 0;
};
